/* eslint-disable react/no-danger */
import React from 'react';
import _get from 'lodash.get';
import {
  isApp,
  getCurrentPage,
  generatePrevNextPageURLforBot,
} from 'utils/getParams';
import {
  loadLayoutDataLB,
  loadCommonData,
  loadSidebarDataMobile,
} from 'reduxUtils/modules_v2/layout';
import { updatePrebidFlag } from 'helpers/ads/redux';
import { newGamSection } from 'helpers/ads/utils';
import processAdsInfo from 'helpers/ads/adsTargetting';
import { getSiteConfig, getCPDConfig } from 'reduxUtils/modules/common';
import processSeoData from 'helpers/seo/liveblogSeoUtilV2';
import {
  commonHeadScriptsMobile,
  commonHeadScripts,
} from 'helpers/scripts/headScripts';
import Layout from 'components_v2/mobile/Layout/Layout';
import { fireGA4Script } from 'utils/common';

import {
  loadLiveblogData,
  loadTimelineData,
  loadFactsheetListicleTabs,
  loadCompleteTimelineData,
  loadSnippetFilterTabsData,
  loadBoardResultData,
  // loadCardInsertLiteData,
} from '../../redux';
import { implementExperiment } from '../../../../utils/primeUtil';
import Liveblog from './Liveblog';
import { TOI_LIVE_DOMAIN } from '../../../../constants';
// import { loadLokSabhaElectionData } from '../../../../components/ElectionV2/loksabha_redux';
// import { loadElectionData } from '../../../../components/ElectionV2/redux';
// import { l1Nav } from '../../../home/layouts/India/mobile/constants';

const pageName = 'liveblog_v2_mobile';

async function action(context, params) {
  const dataPromiseArray = [];
  const isAppView = isApp(context.query);
  const isBrowser = typeof window === 'object';
  const isServer = typeof window === 'undefined';
  const isWapView = true;
  let isSports = false;
  let isWorld = false;

  // existing state
  // eslint-disable-next-line one-var
  let state = context.store.getState();

  const newParams = {
    ...params,
    fullPath: context.path,
    shortPath: `/liveblog/${params.msid}.cms`,
    isWapView,
    skipSubSections: false,
    mobileAtfDfpParams: {
      doNotCollapse: true,
    },
    curpg: getCurrentPage(context.query),
    mobileFbnDfpParams: {
      // doNotCollapse: true,
    },
  };

  if (!state.liveblog_v2 || !state.liveblog_v2.seo) {
    dataPromiseArray.push(
      context.store.dispatch(loadLiveblogData(newParams, isAppView)),
    );
  }

  if (!state.liveblog_v2.timelineData) {
    dataPromiseArray.push(context.store.dispatch(loadTimelineData(newParams)));
  }

  /**
   * Descope it to Non-Sports liveblog only
   */
  if (!state.liveblog_v2.allLiveblogContent) {
    dataPromiseArray.push(
      context.store.dispatch(loadCompleteTimelineData(newParams)),
    );
  }

  /**
   * Descope it to Non-Sports liveblog only
   */
  if (!state.liveblog_v2.listicletabs) {
    dataPromiseArray.push(
      context.store.dispatch(loadFactsheetListicleTabs(newParams)),
    );
  }

  if (isAppView && !state.commonData.data) {
    dataPromiseArray.push(
      context.store.dispatch(loadCommonData(newParams, 'liveblog_v2')),
    );
  } else if (!isAppView && (!state.header.data || !state.footer_v2.data)) {
    dataPromiseArray.push(context.store.dispatch(loadLayoutDataLB(newParams)));
  }

  if (!state.sidebar || !state.sidebar.data) {
    dataPromiseArray.push(
      //passing template name/ resolved routes  to feed instead of entire  articleshow path
      context.store.dispatch(loadSidebarDataMobile(newParams)),
    );
  }

  if (typeof window === 'undefined') {
    dataPromiseArray.push(context.store.dispatch(getSiteConfig()));
  }

  if (typeof window === 'undefined') {
    dataPromiseArray.push(context.store.dispatch(getCPDConfig()));
  }

  // if (!state.liveblog_v2.cardsInsertsLite) {
  //   dataPromiseArray.push(context.store.dispatch(loadCardInsertLiteData()));
  // }

  // wait for responses on server side
  if (
    typeof window === 'undefined' ||
    (typeof window === 'object' &&
      dataPromiseArray.length > 0 &&
      (!state.liveblog_v2 || !state.liveblog_v2.seo))
  ) {
    await Promise.all(dataPromiseArray);
  }

  state = context.store.getState();

  const dataPromiseArray1 = [];

  if (state.liveblog_v2.metaInfo) {
    const { metaInfo } = state.liveblog_v2;
    if (metaInfo && metaInfo.CARDPAGEID && metaInfo.CARDPAGEID !== '') {
      dataPromiseArray1.push(
        context.store.dispatch(loadBoardResultData(metaInfo)),
      );
      await Promise.all(dataPromiseArray1);
    }
  }

  state = context.store.getState();

  /**
   * Descope it to Non-Sports liveblog only
   */
  if (!state.liveblog_v2.lbSnippetFilterTabsMeta) {
    const { metaInfo, timelineData } = state.liveblog_v2;
    const matchtype =
      timelineData && timelineData.matchtype
        ? `cricket-${timelineData.matchtype.toLowerCase()}`
        : undefined;
    if (
      metaInfo &&
      (metaInfo.LiveBlogName ||
        (metaInfo.isCricketLiveblog && typeof matchtype !== 'undefined'))
    ) {
      const liveBlogName = matchtype || metaInfo.LiveBlogName;
      await context.store.dispatch(loadSnippetFilterTabsData(liveBlogName));
    }
  }

  let status = 200;
  let redirect = false;
  let title = 'Get Latest News Updates from Times Of India';
  let dataAvailable = state.liveblog_v2 && state.liveblog_v2.timelineData;
  const liveBlogImageData = state.liveblog_v2.images || null;
  const imageInfo = [];
  let showPreload;
  const forcedErrorStatus =
    state.liveblog_v2 && state.liveblog_v2.forcedErrorStatus
      ? state.liveblog_v2.forcedErrorStatus
      : null;
  if (isServer && !dataAvailable) {
    status = 404;
  }

  if (forcedErrorStatus) {
    status = forcedErrorStatus;
    dataAvailable = false;
  }

  if (dataAvailable) {
    title = state.liveblog_v2.timelineData
      ? state.liveblog_v2.timelineData.title1
      : '';
    const leadImgId =
      liveBlogImageData &&
      liveBlogImageData.length &&
      liveBlogImageData[0] &&
      liveBlogImageData[0].id;
    const imgSize =
      liveBlogImageData &&
      liveBlogImageData.length &&
      liveBlogImageData[0] &&
      liveBlogImageData[0].imagesize;
    if (leadImgId)
      imageInfo.push(
        `https://static.toiimg.com/thumb/imgsize-${imgSize ||
          '12345'},msid-${leadImgId},width-400,resizemode-4/${leadImgId}.jpg`,
      );

    showPreload = imageInfo instanceof Array && imageInfo.length > 0;
  }
  if (
    state &&
    state.liveblog_v2 &&
    state.liveblog_v2.seo &&
    state.liveblog_v2.seo.canonical &&
    typeof state.liveblog_v2.seo.canonical === 'string'
  ) {
    const relativeUrl = new URL(state.liveblog_v2.seo.canonical).pathname;
    if (
      relativeUrl.includes('/liveblog/') &&
      relativeUrl.includes('/sports/')
    ) {
      isSports = true;
    }
    if (relativeUrl.includes('/liveblog/') && relativeUrl.includes('/world/')) {
      isWorld = true;
    }
  }

  if (
    isBrowser &&
    state.liveblog_v2 &&
    state.liveblog_v2.seo &&
    state.liveblog_v2.seo.canonical &&
    typeof state.liveblog_v2.seo.canonical === 'string' &&
    window.location.href.indexOf('?') === -1
  ) {
    const relativeUrl = new URL(state.liveblog_v2.seo.canonical).pathname;
    const urlInBrowser = window.location.pathname || '';
    if (
      urlInBrowser &&
      relativeUrl.toLowerCase() !== urlInBrowser.toLowerCase()
    ) {
      redirect = relativeUrl;
      status = 301;
    }
  }
  if (
    isServer &&
    state.liveblog_v2 &&
    state.liveblog_v2.seo &&
    state.liveblog_v2.seo.canonical &&
    typeof state.liveblog_v2.seo.canonical === 'string' &&
    context.pathname.indexOf('?') === -1
  ) {
    const relativeUrl = new URL(state.liveblog_v2.seo.canonical).pathname;
    const urlInBrowser = context.pathname || '';
    if (
      urlInBrowser &&
      relativeUrl.toLowerCase() !== urlInBrowser.toLowerCase()
    ) {
      redirect = relativeUrl;
      status = 301;
    }
  }

  state = context.store.getState();
  // TODO: Election Widget
  // const electionDataPromiseArray = [];
  // if (
  //   state?.liveblog_v2?.widgets &&
  //   Array.isArray(state?.liveblog_v2?.widgets) &&
  //   state?.liveblog_v2?.widgets.length > 0
  // ) {
  //   const electionwdtElements = state?.liveblog_v2?.widgets.find(
  //     item => item.tn === 'electionwdt',
  //   );
  //   const electionTabs = state.common?.siteConfig?.electionTabs;
  //   if (
  //     electionwdtElements &&
  //     electionTabs &&
  //     Array.isArray(electionTabs) &&
  //     electionTabs.length > 0
  //   ) {
  //     const assemblyElectionSelection = electionTabs.filter(
  //       tab => parseInt(isNaN(tab.index) ? 0 : tab.index, 10) === 2,
  //     );
  //     const lokSabhaElectionSelection = electionTabs.filter(
  //       tab => parseInt(isNaN(tab.index) ? 0 : tab.index, 10) === 1,
  //     );

  //     if (
  //       assemblyElectionSelection &&
  //       Array.isArray(assemblyElectionSelection) &&
  //       assemblyElectionSelection.length > 0 &&
  //       !state?.electionV2?.refreshinterval
  //     ) {
  //       const assemblyElectionUrl =
  //         state.common?.siteConfig?.assemblyElectionMobileUrl;
  //       electionDataPromiseArray.push(
  //         context.store.dispatch(
  //           loadElectionData(null, assemblyElectionUrl, false),
  //         ),
  //       );
  //     }
  //     if (
  //       lokSabhaElectionSelection &&
  //       Array.isArray(lokSabhaElectionSelection) &&
  //       lokSabhaElectionSelection.length > 0 &&
  //       !state?.lokSabhaElection?.refreshinterval
  //     ) {
  //       const loksabhaElectionUrl =
  //         state.common?.siteConfig?.loksabhaElectionMobileUrl;
  //       electionDataPromiseArray.push(
  //         context.store.dispatch(
  //           loadLokSabhaElectionData(null, loksabhaElectionUrl, false),
  //         ),
  //       );
  //     }
  //   }
  // }
  // if (typeof window === 'undefined') {
  //   await Promise.all(electionDataPromiseArray);
  // }

  // state = context.store.getState();
  let adsTargetingObj = {};
  let revWidgets = {};

  const layoutdata = state?.liveblog_v2;
  if (layoutdata && status === 200) {
    const fetchData = {
      layoutdata,
      state,
      context,
      templateConfig: {
        Tmpl_SCN: 'Liveblog',
        Channel: 'toi',
        articleId: _get(params, 'msid', ''),
      },
    };
    const { keyValueObj, revenueData } = await processAdsInfo(fetchData);
    revWidgets = _get(revenueData, 'widgets', {});
    adsTargetingObj = keyValueObj;
  }

  const getLayoutProps = pageTitle => ({
    title: pageTitle,
    params: newParams,
    msid: params.msid,
    subSecSeoLocation: _get(
      state,
      'liveblog_v2.navsubsecs.subsec1.seolocation1',
    ),
    query: Object.keys(context.query).length ? context.query : {},
    layoutType: '',
    hideStickyBackToTop: true,
    rhs: false,
    adPosition: 'masthead',
    showMiniTv: !_get(revWidgets, 'skipminitv', false),
    hideAdCude: _get(revWidgets, 'skipcube', false),
    showTimesTop10: true,
    showAdBlockerInINEU: true,
    hideBackToTop: true,
    hideBreadcrumAtBottom: true,
    pageType: 'LIVEBLOG',
    // hideL2Navigation: true,
    l1Sections: _get(state, `header.data.navigation.topNav.items`),
    hideOpenInAppTopWidget: true,
    mobileFBNAdCode: {
      ..._get(state.liveblog_v2, `ads.dfp.slots.FBN`),
      targetingInfo: {
        ..._get(state.liveblog_v2, `ads.dfp.info`, {}),
      },
    },
    refreshFBNAd: true,
    mobileATFAdCode: {
      ..._get(state.liveblog_v2, `ads.dfp.slots.ATF`),
      targetingInfo: {
        ..._get(state.liveblog_v2, `ads.dfp.info`, {}),
      },
    },
    showCovid19PopUp: true,
    openInAppDll: _get(state.liveblog_v2, `appdll.openinapp`, ''),
    // hideAdBlockerDetector: true, //comment this to add adblocker
    showBreadcrumb: true, // This is done to show breadcrum like web in TOIPR-70587
    breadCrumbTitle: title,
    hideTopSearch: true,
    enableHeaderUnificationVersion: true,
    useStaticOpenAppUrl: true,
  });

  const getComponent = async pageTitle => {
    let returnHtml;

    if (dataAvailable) {
      const prebidObj = _get(
        state,
        `common.siteConfig.prebid.templates.liveblog`,
      );
      const electionFlag = _get(state, `common.siteConfig.showelection`);
      context.store.dispatch(updatePrebidFlag(prebidObj));
      if (isBrowser) {
        window.categoryForGA = `liveblog_new_mweb`;
        window.categoryForSearchGA = 'WAP-TOI-LiveBlog';
        if (
          context.path &&
          context.path.includes('/liveblog/') &&
          context.path.includes('/sports/')
        ) {
          window.categoryForGA = `SportsLiveblog_New`;
        }
      }

      returnHtml = (
        <Layout {...getLayoutProps(pageTitle)}>
          <Liveblog
            query={context.query}
            sharedMsid={context.query.smsid}
            liveblog={state.liveblog_v2}
            timelineData={state.liveblog_v2.timelineData}
            isAppView={isAppView}
            isSports={isSports}
            isWorld={isWorld}
            electionFlag={electionFlag === '1'}
            location={context.path}
          />
        </Layout>
      );
      // }

      return returnHtml;
    }
    return (
      <div>
        Something went wrong. Click{' '}
        <a href="https://timesofindia.indiatimes.com">here</a> to browse TOI
      </div>
    );
  };

  const getMaxAge = () => {
    let maxAge = 10;
    if (state.liveblog_v2 && state.liveblog_v2.maxAge) {
      maxAge = state.liveblog_v2.maxAge;
    }

    return maxAge;
  };

  const getSeoData = async () => {
    const processedSeoData = processSeoData(state.liveblog_v2, state) || {};
    const seoObj =
      state.liveblog_v2 && state.liveblog_v2.seo ? state.liveblog_v2.seo : {};
    const schemaObj =
      state.liveblog_v2 && state.liveblog_v2.schema
        ? state.liveblog_v2.schema
        : [];
    if (schemaObj && schemaObj.length > 0) {
      seoObj.schema = Object.assign(schemaObj, processedSeoData);
    }
    seoObj.ogType = 'liveblog';
    seoObj.article = true;
    return seoObj;
  };

  const getGAConfig = async () => {
    const gaData = {};
    gaData.dimension26 = 'liveblog_exp_new';
    gaData.dimension35 = state?.liveblog_v2?.seo?.title;
    const dim61 =
      state &&
      state.liveblog_v2 &&
      state.liveblog_v2.metaInfo &&
      state.liveblog_v2.metaInfo.Contenttype
        ? state.liveblog_v2.metaInfo.Contenttype
        : '';
    if (dim61) {
      gaData.dimension61 = dim61;
    }

    return gaData;
  };

  const gtmIDForOptimisely = ['GTM-KCRX3PN', 'OPT-MZ46ZWC'];
  if (typeof window !== 'undefined') {
    fireGA4Script({ vmsid: params?.msid });
  }
  const afterAdsScript = [];
  if (state?.liveblog_v2?.metaInfo?.CARDPAGEID !== '') {
    afterAdsScript.push(
      `${TOI_LIVE_DOMAIN}/html_to_pdf/minify-1,version-1.cms`,
      `${TOI_LIVE_DOMAIN}/jspdf/minify-1,version-1.cms`,
    );
  }
  const jNewGam = _get(revWidgets, 'isNewGam', false);
  const isNewGam = jNewGam || newGamSection(adsTargetingObj);

  return {
    chunks: [pageName],
    title,
    seoData: await getSeoData(),
    maxAge: getMaxAge(),
    gaData: await getGAConfig(),
    status,
    component: await getComponent(title),
    preconnectDomains: ['//tpapi.timespoints.com'],
    prevNextLinkForBot: generatePrevNextPageURLforBot(
      context,
      state.liveblog_v2,
    ),
    skipGpt: true,
    pwtHeadTags: true,
    isMaxImagePreview: true,
    headTags: isWapView
      ? [
          ...commonHeadScriptsMobile,
          <script
            dangerouslySetInnerHTML={{
              __html: implementExperiment(),
            }}
          />,
        ]
      : [...commonHeadScripts],
    imageInfo,
    showPreload,
    isPerfExperimented: !state.isPrime,
    useVariableFonts: !state.isPrime,
    inlineFirstFoldCSS: !state.isPrime,
    gtmIDList: gtmIDForOptimisely,
    adsTargetingObj,
    skipCLSHandler: true,
    redirect,
    afterAdsScript,
    skipRouteAds: state?.liveblog_v2?.metaInfo?.SpecialID === 'noad',
    isNewGam,
    skipColumbiaScript: _get(revWidgets, 'skipCTN', false),
  };
}

export default action;
